<mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
<h1>{{ 'billing.CRM.title' | translate }}</h1>

<main class="CRMCardContainer">
    <app-crm-filter-form [clients]="clients" [filterForm]="filterForm" (onFilterFormSubmited)="onSubmitFilterForm()"
        (onFilterFormReset)="onResetFilterForm()">
    </app-crm-filter-form>

    <app-crm-charts [clientStatisticsByMonth]="clientStatisticsByMonth"
        [clientStatisticsByYear]="clientStatisticsByYear"></app-crm-charts>

    <section class="byMonthCard">
        <app-crm-total-card class="totalCard" *ngIf="clientStatisticsByMonth"
            [total]="clientStatisticsByMonth.total"></app-crm-total-card>

        <app-crm-table-by-month class="tableCard" *ngIf="clientStatisticsByMonth"
            [statistics]="clientStatisticsByMonth.statisticsByMonth"></app-crm-table-by-month>
    </section>
</main>